import "./insGridControls.scss";
import React from "react";
import { InsGridGroupingButton } from "./insGridGroupingButton";
import { InsGridInvestorViewToggle } from "./insGridInvestorViewToggle";
import { InsGridSwitcherToggle } from "./insGridSwitcherToggle";
import InsAssignTagsButton from "components/tags/InsAssignTagsButton";
export const InsGridControlsRight = (props) => React.createElement("div", { className: "gridControls" },
    React.createElement(InsGridInvestorViewToggle, { ...props, key: `investorToggle-${props.stateId}` }),
    React.createElement(InsGridSwitcherToggle, { ...props, key: `gridSwitcher-${props.stateId}` }),
    React.createElement(InsGridGroupingButton, { popoverRef: props.popoverRef, ...props, key: `groupingButton-${props.stateId}` }),
    props.allowTags && React.createElement(InsAssignTagsButton, { entityType: props.tagsEntityType }));
